<template>
  <ul
    class="app-radio-group__list"
    :class="`app-radio-group__list_${orientation}`"
  >
    <li
      v-for="(level, index) in levels"
      :key="index"
      class="app-radio-group__item"
      :class="`app-radio-group__item_${orientation}`"
    >
      <app-radio
        :id="level.id"
        :model-prop="value"
        :value="level.id"
        :name="name"
        class="app-radio-group__button"
        @change="changeRadio"
      >
        {{ level[itemText] }}
      </app-radio>
    </li>
  </ul>
</template>

<script>
import AppRadio from '../Base/AppRadio';

export default {
  name: 'AppRadioGroup',
  components: {
    AppRadio,
  },
  model: {
    prop: 'value',
    event: 'changeRadioButton',
  },
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    levels: {
      type: Array,
      required: true,
    },
    orientation: {
      type: String,
      default: 'vertical',
    },
    name: {
      type: String,
      default: 'radio',
    },
    itemText: {
      type: String,
      default: 'value',
    },
  },
  methods: {
    changeRadio(value) {
      this.$emit('changeRadioButton', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-radio-group {
    display: inline-flex;
    align-items: center;

    &__item {
      list-style-type: none;

      &_horizontal {
        display: inline-flex;
        margin-right: 15px;
      }
      &_vertical {
        margin-top: 10px;
      }
    }

    &__list {
      margin: 0;
      &_vertical {
        padding-left: 0;
      }
      &_horizontal {
        padding-left: 15px;
      }
    }

    &__name {
      top: 0;
      font-size: 15px;
    }
  }

</style>
